import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICouponState {
  loading: boolean;
  coupon: string;
  isDay0: boolean;
}

export const initialState: ICouponState = {
  loading: true,
  coupon: '',
  isDay0: false,
};

export interface IUpdateCouponPayload {
  coupon: string;
  isDay0: boolean;
}

export const statePropName = 'coupon';

const couponSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    couponInit(state: ICouponState) {
      return { ...initialState };
    },
    couponUpdate: {
      reducer(state: ICouponState, action: PayloadAction<IUpdateCouponPayload>) {
        state.loading = false;
        state.coupon = action.payload.coupon;
        state.isDay0 = action.payload.isDay0;
      },
      prepare(coupon: string, isDay0: boolean) {
        return { payload: { coupon, isDay0 } };
      },
    },
    couponReset(state: ICouponState) {
      return {
        ...initialState,
        loading: false,
      };
    },
  },
});

export const CouponActions = couponSlice.actions;
export default couponSlice.reducer;
